import { useState, useEffect, useCallback } from 'react';
import axios from 'axios'; // Import Axios


const useScheduleAppointment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [blockedTimes, setBlockedTimes] = useState([]);
  const [appointments, setAppointments] = useState([]);


  const fetchAppointmentsAndBlockedTimes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const appointmentsResponse = await axios.get('https://api.samstreeservice.com/api/appointments');
      setAppointments(appointmentsResponse.data);

      const blockedTimesResponse = await axios.get('https://api.samstreeservice.com/api/blocked-times');
      setBlockedTimes(blockedTimesResponse.data);

      localStorage.setItem('blockedTimes', JSON.stringify(blockedTimesResponse.data));
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch data.');
      setMessage('Failed to fetch data.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAppointmentsAndBlockedTimes();
  }, [fetchAppointmentsAndBlockedTimes]);

  // Fetch initial data
  useEffect(() => {
    fetchAppointmentsAndBlockedTimes();
  }, [fetchAppointmentsAndBlockedTimes]);

  // Connect to SSE endpoint and listen for events
  useEffect(() => {
    const timestamp = new Date().toISOString();
    console.log(`[${timestamp}] useScheduleAppointment: Creating EventSource connection`);

    const eventSource = new EventSource('https://api.samstreeservice.com/events');

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setAppointments(data.appointments);
      setBlockedTimes(data.blockedTimes);
    };

    eventSource.onerror = (err) => {
      console.error('SSE error:', err);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, []);


  /*useEffect(() => {
    fetchBlockedTimes();
  }, []);*/

  /*const fetchBlockedTimes = async () => {
    try {
      const response = await fetch('http://localhost:5001/api/blocked-times');
      const data = await response.json();
      setBlockedTimes(data);
    } catch (err) {
      setError(err);
      setMessage('Failed to fetch blocked times.');
    }
  };*/
  /*const fetchBlockedTimes = async () => {
    try {
      const response = await axios.get('http://localhost:5001/api/blocked-times');
      setBlockedTimes(response.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || err);
      setMessage('Failed to fetch blocked times.');
    }
  };*/

  const scheduleAppointment = async ({ name, date, phoneNumber, email, address }) => {
    console.log('scheduleAppointment called with:', { name, date, phoneNumber, email, address });
    setLoading(true);
    setError(null);
    setSuccess(false);
    setMessage('');
    console.log('date before send:', date);

  try {
    // Retrieve existing appointments from localStorage (if needed for client-side checks)
    const appointments = JSON.parse(localStorage.getItem('appointments')) || [];
    const blockedTimes = JSON.parse(localStorage.getItem('blockedTimes')) || [];

    // Check for double booking (client-side)
    const isDoubleBooked = appointments.some(
      (appointment) => new Date(appointment.date).getTime() === new Date(date).getTime()
    );

    // Check if the selected time is blocked (client-side)
    const isBlocked = blockedTimes.some(
      (blocked) => new Date(blocked).getTime() === new Date(date).getTime()
    );

    if (isDoubleBooked || isBlocked) {
      setMessage('This time slot is already booked. Please choose another.');
      setLoading(false);
      return;
    }

    // Send appointment data to the server
    const response = await axios.post('https://api.samstreeservice.com/api/schedule-appointment', {
      name,
      date,
      phoneNumber,
      email,
      address,
    });

    //if (!response.data.success) {
      //throw new Error(response.data.message || 'An error occurred');
    //}

    // Generate a unique ID (server should generate this)
    //const id = Date.now().toString();

    // Update localStorage (if needed for client-side)
    //appointments.push({ id, name, date, phoneNumber, email, address });
    //localStorage.setItem('appointments', JSON.stringify(appointments));
      /*const id = response.data.appointment.id;  
      const appointment = { id, name, date, phoneNumber, email, address };
      appointments.push(appointment);
      localStorage.setItem('appointments', JSON.stringify(appointments));*/

    setSuccess(true);
    setMessage('Appointment booked successfully!');
    alert('Appointment booked successfully!');
    //await getAppointments();
    await fetchAppointmentsAndBlockedTimes(); 
  } catch (err) {
    setError(err.response?.data?.message || err.message || 'An error occurred while booking the appointment.');
    setMessage(err.response?.data?.message || err.message || 'An error occurred while booking the appointment.');
    alert('An error occurred. Please try again.');
  } finally {
    setLoading(false);
  }
};

  /*const scheduleAppointment = async ({ name, date, phoneNumber, email, address }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setMessage('');

    try {
      const response = await fetch('http://localhost:5001/api/schedule-appointment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, date, phoneNumber, email, address }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to schedule appointment.');
      }

      setSuccess(true);
      setMessage('Appointment booked successfully!');
      alert('Appointment booked successfully!');
    } catch (err) {
      setError(err);
      setMessage(err.message || 'An error occurred while booking the appointment.');
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };*/

  /*const scheduleAppointment = async ({ name, date, phoneNumber, email, address }) => {
    console.log('scheduleAppointment called with:', { name, date, phoneNumber, email, address }); 
    setLoading(true);
    setError(null);
    setSuccess(false);
    setMessage('');
    console.log('date before send:', date);

    try {
      await axios.post('http://localhost:5001/api/schedule-appointment', {
        name,
        date,
        phoneNumber,
        email,
        address,
      });

      setSuccess(true);
      setMessage('Appointment booked successfully!');
      alert('Appointment booked successfully!');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'An error occurred while booking the appointment.');
      setMessage(err.response?.data?.message || err.message || 'An error occurred while booking the appointment.');
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };*/

  /*const blockTimeSlot = async (date, isAllDay = false) => {
    try {
      const response = await fetch('http://localhost:5001/api/block-time', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ date, isAllDay }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to block time slot.');
      }
      fetchBlockedTimes();
      setMessage('Time slot blocked successfully!');
    } catch (err) {
      setError(err);
      setMessage(err.message || 'Failed to block time slot.');
    }
  };*/

  const blockTimeSlot = async (date, isAllDay = false) => {
    try {
      const response = await axios.post('https://api.samstreeservice.com/api/block-time', {
        date: date.toISOString(), // Convert date to ISO string
        isAllDay,
      });
  
      if (response.status !== 200) {
        throw new Error(response.data.message || 'Failed to block time slot.');
      }
  
      //await getBlockedTimes(); // Refetch blocked times
      await fetchAppointmentsAndBlockedTimes(); 
      setMessage('Time slot blocked successfully!');
    } catch (err) {
      console.error('Error blocking time slot:', err);
      setError(err.response?.data?.message || err.message || 'Failed to block time slot.');
      setMessage(err.response?.data?.message || err.message || 'Failed to block time slot.');
    }
  };

  /*const getAppointments = async () => {
    try {
      const response = await fetch('http://localhost:5001/api/appointments');
      const data = await response.json();
      localStorage.setItem('appointments', JSON.stringify(data)); // Update local storage
      return data;
    } catch (err) {
      setError(err);
      setMessage('Failed to fetch appointments.');
      return JSON.parse(localStorage.getItem('appointments')) || []; // Read from local storage if network fails
    }
  };*/

  /*const getAppointments = async () => {
    try {
      const response = await axios.get('http://localhost:5001/api/appointments');
      //localStorage.setItem('appointments', JSON.stringify(response.data)); 
      setAppointments(response.data); //update state
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch appointments.');
      setMessage('Failed to fetch appointments.');
      return [];
    }
  };*/

  /*const getAppointments = useCallback(async () => {
    try {
      const response = await axios.get('http://localhost:5001/api/appointments');
      console.log('Appointments fetched:', response.data);
      setAppointments([...response.data]);
            console.log('Appointments state after update:', appointments);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch appointments.');
      setMessage('Failed to fetch appointments.');
      return [];
    }
  }, [setAppointments, setError, setMessage]);*/


  /*const getBlockedTimes = async () => {
    try {
      const response = await fetch('http://localhost:5001/api/blocked-times');
      const data = await response.json();
      localStorage.setItem('blockedTimes', JSON.stringify(data)); // Update local storage
      return data;
    } catch (err) {
      setError(err);
      setMessage('Failed to fetch blocked times.');
      return JSON.parse(localStorage.getItem('blockedTimes')) || []; // Read from local storage if network fails
    }
  };*/

  /*const getBlockedTimes = useCallback(async () => {
    try {
      const response = await axios.get('http://localhost:5001/api/blocked-times');
      localStorage.setItem('blockedTimes', JSON.stringify(response.data));
      return response.data;
    } catch (err) {
      setError(err);
      setMessage('Failed to fetch blocked times.');
      return JSON.parse(localStorage.getItem('blockedTimes')) || [];
    }
  }, [setError, setMessage]);*/

  /*const getBlockedTimes = async () => {
    try {
      const response = await axios.get('http://localhost:5001/api/blocked-times');
      localStorage.setItem('blockedTimes', JSON.stringify(response.data));
      return response.data;
    } catch (err) {
      setError(err);
      setMessage('Failed to fetch blocked times.');
      return JSON.parse(localStorage.getItem('blockedTimes')) || [];
    }
  };*/

  /*const deleteAppointment = async (id) => {
    try {
      const response = await fetch(`http://localhost:5001/api/appointments/${id}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete appointment.');
      }

      setMessage('Appointment deleted successfully!');
    } catch (err) {
      setError(err);
      setMessage(err.message || 'Failed to delete appointment.');
    }
  };*/

  const deleteAppointment = async (id) => {
    setLoading(true);
      console.log('Deleting appointment with id:', id);
      console.log('Appointments before delete:', appointments);
    try {
      await axios.delete(`https://api.samstreeservice.com/api/appointments/${id}`);
     /* const updatedAppointments = appointments.filter(appointment => appointment.id !== id);*/
     /*const updatedAppointments = await getAppointments();
     setAppointments([...updatedAppointments]);*/
      //console.log('Appointments after delete:', updatedAppointments);
      //console.log('Current appointments state:', appointments);
      //await getAppointments();
      await fetchAppointmentsAndBlockedTimes(); 
      setMessage('Appointment deleted successfully!');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to delete appointment.');
      setMessage('Failed to delete appointment.');
    } finally {
      setLoading(false);
    }
  };

  /*const deleteBlockedTime = async (dateToDelete) => {
    try {
      const response = await fetch(`http://localhost:5001/api/blocked-times/${dateToDelete}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete blocked time.');
      }
      //fetchBlockedTimes();
      const updatedBlockedTimes = await getBlockedTimes();
      localStorage.setItem('blockedTimes', JSON.stringify(updatedBlockedTimes));
      setMessage('Blocked time deleted successfully!');
    } catch (err) {
      setError(err);
      setMessage(err.message || 'Failed to delete blocked time.');
    }
  };*/

  /*const deleteBlockedTime = async (dateToDelete) => {
    try {
      const response = await fetch(`http://localhost:5001/api/blocked-times/${encodeURIComponent(dateToDelete)}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete blocked time.');
      }

      // Update local storage and state directly without calling getBlockedTimes
      const currentBlockedTimes = JSON.parse(localStorage.getItem('blockedTimes')) || [];
      const updatedBlockedTimes = currentBlockedTimes.filter(
        (blocked) => blocked.date !== dateToDelete
      );
      localStorage.setItem('blockedTimes', JSON.stringify(updatedBlockedTimes));
      setMessage('Blocked time deleted successfully!');
      return updatedBlockedTimes;

    } catch (err) {
      setError(err);
      setMessage(err.message || 'Failed to delete blocked time.');
    }
  };*/


/*const deleteBlockedTime = async (dateToDelete) => {
  try {
    console.log('Deleting blocked time:', dateToDelete);
    await axios.delete(`http://localhost:5001/api/blocked-times/${encodeURIComponent(dateToDelete)}`);

    // Update local storage and state directly without calling getBlockedTimes
    const currentBlockedTimes = JSON.parse(localStorage.getItem('blockedTimes')) || [];
    const updatedBlockedTimes = currentBlockedTimes.filter(
      (blocked) => blocked.date !== dateToDelete
    );
    localStorage.setItem('blockedTimes', JSON.stringify(updatedBlockedTimes));
    setMessage('Blocked time deleted successfully!');
    //console.log('Blocked time deleted successfully!');
    return updatedBlockedTimes;

  } catch (err) {
    console.error('Error deleting blocked time:', err);
    setError(err);
    setMessage(err.response?.data?.message || 'Failed to delete blocked time.');
  }
};*/

const deleteBlockedTime = async (dateToDelete) => {
  setLoading(true);
  setError(null);
  try {
    await axios.delete(`https://api.samstreeservice.com/api/blocked-times/${encodeURIComponent(dateToDelete)}`);
    setMessage('Blocked time deleted successfully!');
    await fetchAppointmentsAndBlockedTimes(); // Refetch data
  } catch (err) {
    setError(err.response?.data?.message || 'Failed to delete blocked time.');
    setMessage('Failed to delete blocked time.');
  } finally {
    setLoading(false);
  }
};

  /*const blockTime = async (slotTime) => {
    try {
      const response =  await fetch('http://localhost:5001/api/block-time', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ date: slotTime, isAllDay: false }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to block time.');
      }
      fetchBlockedTimes();
      setMessage('Time blocked successfully!');
    } catch (err) {
      setError(err);
      setMessage(err.message || 'Failed to block time.');
    }
  };*/

  

/*const blockTime = async (slotTime) => {
  try {
    //console.log('Blocking time:', slotTime);
    await axios.post('http://localhost:5001/api/block-time', { date: slotTime, isAllDay: false });

    // Update state and local storage directly (similar to original function)
    const newBlockedTimes = [...blockedTimes, slotTime];
    localStorage.setItem('blockedTimes', JSON.stringify(newBlockedTimes));
    setBlockedTimes(newBlockedTimes);
    setMessage('Time blocked successfully!');
    console.log('Time blocked successfully!');

  } catch (error) {
    console.error('Error blocking time:', error);
    setMessage(`Error: ${error.response?.data?.message || error.message}`);
  }
};*/

const blockTime = async (slotTime) => {
  setLoading(true);
  setError(null);
  try {
    await axios.post('https://api.samstreeservice.com/api/block-time', { date: slotTime, isAllDay: false });
    setMessage('Time blocked successfully!');
    await fetchAppointmentsAndBlockedTimes(); // Refetch data
  } catch (error) {
    setError(error.response?.data?.message || error.message);
    setMessage(error.response?.data?.message || error.message);
  } finally {
    setLoading(false);
  }
};




  return {
    scheduleAppointment,
    //getAppointments,
    appointments: () => appointments,
    deleteAppointment,
    //getBlockedTimes,
    getBlockedTimes: () => blockedTimes,
    blockTimeSlot,
    deleteBlockedTime,
    blockTime,
    loading,
    error,
    success,
    setSuccess,
    message,
  };
};

export default useScheduleAppointment;